import { HTMLAttributes } from 'react'
import Link from 'next/link'

import Container from '@/components/base/Container'
import Motion from '@/components/base/Motion'
import Typography from '@/components/base/Typography'

import { opacityReveal } from './animations/opacity'
import { cn } from '@/lib/utils'

export type ProfessionistiBlockProps = HTMLAttributes<HTMLElement> &
  Partial<{
    collection: {
      link: string
      role: string
      image: string
      title: string
      linkedin: string
    }[]
  }>

const ProfessionistiBlock = ({ collection }: ProfessionistiBlockProps) => {
  return (
    <section data-gallery-block>
      <Container>
        <div className="flex flex-wrap gap-[60px_20px] md:gap-[60px] lg:gap-[120px]">
          {collection?.map((item, index) => (
            <Motion key={index} animation={opacityReveal}>
              <Link
                href={item?.link || '#'}
                key={index}
                className={cn(
                  'flex flex-col justify-between gap-[30px]',
                  'flex-[0_0_calc(50%-10px)]',
                  'md:flex-[0_0_calc(50%-30px)]',
                  'lg:flex-[0_0_calc(33.333%-80px)]',
                  {
                    'pointer-events-none': !item.link
                  }
                )}
                scroll={false}
              >
                {item.image ? (
                  <div
                    className={cn(
                      'relative aspect-[0.75] overflow-hidden rounded-[5px]'
                    )}
                  >
                    <img
                      src={item.image}
                      alt={item.title}
                      className="h-full w-full object-cover"
                    />
                  </div>
                ) : null}

                <div className="flex justify-between">
                  <div className="flex flex-col gap-[10px]">
                    {item.role ? (
                      <Typography variant="label">{item.role}</Typography>
                    ) : null}
                    {item.title ? (
                      <Typography variant="h5" data-gallery-block-title>
                        {`<b>${item.title}</b>`}
                      </Typography>
                    ) : null}
                  </div>
                </div>
              </Link>
            </Motion>
          ))}
        </div>
      </Container>
    </section>
  )
}

export default ProfessionistiBlock
